import initTheme from "./scripts/theme";
import initBackdrop from "./scripts/backdrop";
import initTyper from "./scripts/typer";
import initSkills from "./scripts/skills";
import initStories from "./scripts/stories";
import initBlog from "./scripts/blog";
import initHint from "./scripts/hint";
import initSlider from "./scripts/slider";
import initChat from "./scripts/chat";
import initContact from "./scripts/contact";
import initSheet from "./scripts/sheet";

initTheme();

initBackdrop();
initTyper();
// Before the slider, so they hear the first "slidechange"
initSkills();
initStories();
initBlog();
initHint();
initSlider();
initChat();
initContact();
initSheet();
